// Turns a landing URL into the share.inbound event the viewer reports, so a
// curator's "returning users" count moves when someone opens their link.
// Share links send people to these routes with ?ref=<referrer id>.
const ROUTES = [
  [/^\/app\/Music\/([a-f\d]{24})/i, "playlist"],
  [/^\/app\/MyMusic\/([a-f\d]{24})/i, "playlist"],
  [/^\/app\/SongDetails\/([a-f\d]{24})/i, "song"],
  [/^\/app\/ArtistProfile\/([a-f\d]{24})/i, "profile"],
  [/^\/app\/LiveVideoStreaming\/([a-f\d]{24})/i, "livestream"],
  [/^\/app\/video-player\/[a-f\d]{24}\/([a-f\d]{24})/i, "video"],
];

export function shareAssetFromPath(pathname) {
  for (const [re, assetType] of ROUTES) {
    const m = re.exec(pathname || "");
    if (m) return { assetType, assetId: m[1] };
  }
  return null;
}

/** { assetType, assetId, ref } for a landing, or null when it is not a shared arrival. */
export function shareInboundFromLocation({ pathname, search }, viewerId) {
  const params = new URLSearchParams(search || "");
  const ref = params.get("ref") || params.get("referralId");
  if (!ref || !/^[a-f\d]{24}$/i.test(ref)) return null;
  if (viewerId && String(viewerId) === ref) return null;
  const asset = shareAssetFromPath(pathname);
  if (!asset) return null;
  return { ...asset, ref };
}

export default shareInboundFromLocation;
